import { useStyleSheet } from '../../../../hooks/useStyleSheet';

export const useStyles = (isActive: boolean) =>
  useStyleSheet((theme) => ({
    pageNumber: {
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: `calc(${theme.spacing.primary} + ${theme.spacing.secondary})`,
      minHeight: `calc(${theme.spacing.primary} + ${theme.spacing.secondary})`,
      transition: `all ${theme.transitions.primary}`,
      background: isActive ? theme.palette.common.white : undefined,
      borderRadius: theme.borderRadius.md,
      ':hover': {
        background: 'white',
      },
      ':hover > label': {
        color: theme.palette.primary.main,
      },
      '& > label': {
        color: isActive ? theme.palette.primary.main : undefined,
      },
    },
    label: {
      width: '2rem',
    },
  }));
